import { Link } from 'react-router';
import DownloadButtons from '~/components/DownloadButtons'
import Footer from '~/components/Footer'
import DownloadFeatures from '~/features/download/DownloadFeatures'
import Wave from '~/features/download/Wave'
import useTranslator from '~/lib/useTranslator'

export default function DownloadIndex() {
  const Translator = useTranslator()

  return (
    <>
      <section className="bg-primary-color">
        <div className="bg-primary-color w-full max-w-screen-sm mx-auto px-4 py-12">
          <div className="flex flex-col gap-6 justify-center text-white">
            <h2 className="text-center text-white font-semibold text-2xl">
              {Translator.singular('You have been invited to join a team on Heja')}
            </h2>
            <div className="text-white flex flex-col gap-4 md:bg-white text-center md:text-left rounded-lg py-8 px-4 md:text-black w-full max-w-3xl mx-auto">
              <h2 className="text-white md:text-black-text font-semibold text-lg">
                {Translator.singular('Download Heja & join your team')}
              </h2>
              <hr className="border-white/50 md:border-black/10" />
              <div>
                <h3 className="font-semibold">{Translator.singular('How do I join a team?')}</h3>
                <p>
                  {Translator.singular(
                    'First, download the Heja app. Then create an account and use the team code to join your team.'
                  )}
                </p>
              </div>
              <hr className="border-white/50 md:border-black/10" />
              <div>
                <h3 className="font-semibold">{Translator.singular('What is a team code?')}</h3>
                <p>
                  {Translator.singular(
                    'The team code is your invitation to the team. Use it to invite new members to join your team and download the app. It’s also used in the app to join an existing team.'
                  )}
                </p>
              </div>

              <div className="flex justify-center">
                <DownloadButtons />
              </div>
            </div>
          </div>

          <div className="hidden md:block text-white text-center mt-4">
            <p>
              {Translator.singular('Heja is a sports team communication & activity planning app.')}
            </p>
            <p>
              <Link to="/about" className="underline">
                {Translator.singular('Read more about Heja.')}
              </Link>
            </p>
            <aside className="text-white/70">
              <small>©{new Date().getFullYear()} Heja. All rights reserved.</small>
              <small>
                <Link to="/terms">Terms</Link> & <Link to="/privacy">Privacy</Link>
              </small>
            </aside>
          </div>
        </div>
      </section>

      <div className="md:hidden w-full overflow-hidden translate-y-[-1px] fill-primary-color">
        <Wave fill="#3AC47F" />
      </div>

      <DownloadFeatures />

      <Footer />
    </>
  )
}
